import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, output } from '@angular/core';

export type MtHeroPillIcon = 'locked' | 'unlocked';

/**
 * The small pill in the corner of a hero: what state the screen is in, and sometimes the one
 * action that changes it.
 *
 * Privacy should be visible without being alarming, so this sits in the band rather than shouting
 * from a banner. When it is pressable it carries the lock action that used to live in the footer —
 * the same call, moved to where the state it changes is shown.
 */
@Component({
  selector: 'app-hero-pill',
  standalone: true,
  imports: [NgTemplateOutlet],
  templateUrl: './mt-hero-pill.component.html',
  styleUrl: './mt-hero-pill.component.scss',
})
export class MtHeroPillComponent {
  @Input() label = '';
  @Input() icon: MtHeroPillIcon = 'locked';
  /** A pill that does something is a button; one that only reports is not. */
  @Input() pressable = false;

  readonly pressed = output();
}
